/**
 * Scroll-lock guard.
 *
 * The theme locks scrolling by putting `no-scroll` (overflow:hidden) on <html>
 * whenever a drawer, modal or popover opens, and removes it on close.
 *
 * That breaks on a back/forward-cache restore, which is the normal way mobile
 * Safari and Chrome return you to a page:
 *
 *   add to cart  ->  cart drawer opens  ->  <html class="no-scroll">
 *   tap Checkout ->  navigate away
 *   tap Back     ->  page restored from bfcache, class still applied,
 *                    drawer JS does not re-run, nothing removes it
 *   result       ->  the page cannot be scrolled
 *
 * On restore, clear the lock — but only when nothing is genuinely open, so a
 * drawer that really is showing keeps its lock and behaves normally.
 */
(function() {
  'use strict';

  var OPEN_SELECTOR = [
    '.Drawer[aria-hidden="false"]',
    '.Modal[aria-hidden="false"]',
    '.Popover[aria-hidden="false"]',
    '.PageOverlay.is-visible'
  ].join(', ');

  function somethingIsOpen() {
    return !!document.querySelector(OPEN_SELECTOR);
  }

  function releaseLock() {
    if (somethingIsOpen()) return;

    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('PairLightbox--open');

    // A lightbox restored from bfcache would sit over the page with nothing
    // left to close it.
    var stale = document.querySelector('.PairLightbox');
    if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
  }

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) releaseLock();
  });

  // Some browsers restore without setting persisted; a history move back onto
  // a frozen page should recover too.
  window.addEventListener('popstate', releaseLock);

  // Last resort: if the page is visible again and nothing is open, a lingering
  // lock is always wrong.
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) releaseLock();
  });
})();
